// extracted by mini-css-extract-plugin
export var avatarContainer = "_3v-0";
export var gray = "_3v-f";
export var green = "_3v-c";
export var icon = "_3v-9";
export var image = "_3v-1";
export var lg = "_3v-6";
export var md = "_3v-5";
export var presenceDot = "_3v-b";
export var red = "_3v-d";
export var sm = "_3v-4";
export var status = "_3v-a";
export var xl = "_3v-7";
export var xs = "_3v-3";
export var xxl = "_3v-8";
export var xxs = "_3v-2";
export var yellow = "_3v-e";